var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserKpi',{attrs:{"kpiIds":_vm.config.link_data,"kpiBackgrounds":_vm.config.property_data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }